import AntDrawer from 'antd-core/es/drawer';
import styled from 'styled-components';
import { withInjectedClassName } from '../../hocs/withInjectedClassName/withInjectedClassName.js';
import { scrollbar } from '../../styling/css/scrollbar.js';

const Root = styled(withInjectedClassName(AntDrawer, 'rootClassName')) `
  &.tend-ui-drawer {
    .tend-ui-drawer-body {
      ${scrollbar}
    }
    .tend-ui-drawer-header-title {
      flex-direction: row-reverse;
    }
    .tend-ui-drawer-close {
      margin-inline-end: 0px;
    }
  }
`;

export { Root };
//# sourceMappingURL=styled.js.map
